import React from "react";
import { Card, Image, Row, Col } from "react-bootstrap";
import Particles from "react-particles-js";
import "./assets/css/styles.scss";
import "./stylecards.css";
import Aux from "../../hoc/_Aux";
import Breadcrumb from "../../App/layout/AdminLayout/Breadcrumb";
import icon1 from "./assets/images/icon1.png";
import icon2 from "./assets/images/icon2.png";
import icon3 from "./assets/images/icon3.png";
import icon4 from "./assets/images/icon4.png";
import Accelerate1 from "../../assets/images/Accelerate1.png";
import Commercial1 from "../../assets/images/Commercial1.png";
import CostEfficient1 from "../../assets/images/CostEfficient1.png";
import Stopwatch2 from "../../assets/images/Stopwatch2.png";
import Reuse1 from "../../assets/images/Reuse1.png";
import Data1 from "../../assets/images/Data1.png";
import components from "../../assets/images/components.png";
import logo1 from "./assets/images/logo1.png";
import logo3 from "./assets/images/logo3.png";
import logo4 from "./assets/images/logo4.png";
import FooterComponent from "./FooterComponent";
import FloatingButton from "./FloatingButton";
import ParticleConfig from "./particlejsconfig";
import LpNavbar from "./LandingPageNavbar";
import aboutImg from "./assets/images/maestro-about.png";
import axios from "axios";
import { adalApiFetch } from "../../adalConfig";
import LatestUpdate from "./LatestUpdateComponent";
import { LANDINGPAGE_BASE_URL } from "../../App/serverConfig";
import AADService from "../../AADService";
import Aos from "aos";
import "aos/dist/aos.css";
import maerskLogo from "./assets/images/maersk_logo.png";

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.aadService = new AADService();
    this.state = {
      modalShow: false,
      data: [],
      hasRole: false,
    };
  }
  componentDidMount() {
    adalApiFetch(axios.get, ` ${LANDINGPAGE_BASE_URL}/v0/admin/updates`, {
      credentials: "include",
    }).then((response) => {
      this.setState({ data: response.data });
    });
    let role = this.aadService.getRoles();
    this.setState({ hasRole: role });

    Aos.init({ duration: 600 });
  }
  render() {
    return (
      <Aux>
        <Breadcrumb />

        <div className="wrapper">
          <div>
            <FloatingButton />
            <LpNavbar hasRole={this.state.hasRole} />
            <div className="main" id="main">
              <div className="hero-section app-hero">
                <p id="lp-text" data-aos="zoom-in-up">
                  <Image
                    src={maerskLogo}
                    alt="MaerskLogo"
                    height="50rem"
                    width="200rem"
                  />
                  <br />
                  <span className="lp-text-header">Experience Maestro</span>
                  <br />
                  <br />
                  <span>
                    Transforming container logistics using Maersk data
                  </span>
                </p>
                <div id="particle">
                  <Particles params={ParticleConfig} />
                </div>
              </div>

              <div className="container-bgimage-ship">
                <div className="bodycontent">
                  <div className="service-section">
                    <div className="container pl-4">
                      <Row className="justify-content-md-center">
                        <Col sm={2} md={12} style={{ paddingTop: "20px" }}>
                          <Row className="justify-content-md-center">
                            <Col
                              sm={2}
                              md={10}
                              style={{
                                paddingBottom: "10px",
                                paddingTop: "25px",
                                textAlign: "center",
                                fontSize: "28px",
                              }}
                            >
                              <div data-aos="zoom-in">
                                <p style={{ fontWeight: "bold" }}>
                                  What is Maestro?
                                </p>
                              </div>
                            </Col>
                          </Row>
                          <Row className="justify-content-md-center">
                            <Col
                              sm={2}
                              md={12}
                              style={{ paddingBottom: "0px" }}
                            >
                              <Row className="justify-content-md-center">
                                <div data-aos="zoom-in">
                                  <div className="Maestromaincard">
                                    <div className="Maestromaincard-text">
                                      <p
                                        style={{
                                          paddingLeft: "3px",
                                          paddingRight: "3px",
                                        }}
                                        className="services-description"
                                      >
                                        The maestro is a platform ecosystem to
                                        transform the shipping industry through
                                        data. A single source of truth across
                                        the organization providing a secure,
                                        scalable and cloud based platform to
                                        accelerate our transformation journey to
                                        be the global Integrator of container
                                        logistics.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </Row>
                            </Col>
                          </Row>
                          {/* 
													<Row className='justify-content-md-center'>
														<Col sm={4} md={4}>
															<div data-aos='fade-right'>
																<p
																	style={{
																		fontWeight: "bold",
																		fontSize: "25px",
																		color: "white",
																		paddingTop: "180px",
																		paddingBottom: "10px",
																	}}
																>
																	Maestro for Managers
																</p>
															</div>
														</Col>
														<Col sm={4} md={7}>
															<div data-aos='fade-left'>
																<div className='justify-content-md-center'>
																	<div
																		className='VideoCards'
																		style={{ paddingLeft: "3.4px" }}
																	>
																		<ReactPlayer
																			className='react-player'
																			controls={true}
																			light={manager1}
																			height='360px'
																			width='623px'
																			url='https://my.maerskgroup.com/personal/vinayak_v_maersk_com/Documents/Maestro Introduction - The Manager.mp4'
																		/>
																	</div>
																</div>
															</div>
														</Col>
													</Row>
													<br /> <br />
													<Row
														className='justify-content-md-center'
														style={{ paddingTop: "30px" }}
													>
														<Col sm={4} md={7}>
															<div data-aos='fade-right'>
																<div className='justify-content-md-center'>
																	<div
																		className='VideoCards'
																		style={{ paddingLeft: "3.5px" }}
																	>
																		<ReactPlayer
																			className='react-player'
																			controls={true}
																			light={BA}
																			height='360px'
																			width='623px'
																			url='https://my.maerskgroup.com/:v:/r/personal/vinayak_v_maersk_com/Documents/Maestro_Introduction_Business_Analyst.mp4'
																		/>
																	</div>
																</div>
															</div>
														</Col>
														<Col sm={4} md={4}>
															<div data-aos='fade-left'>
																<p
																	style={{
																		fontWeight: "bold",
																		fontSize: "25px",
																		color: "white",
																		paddingTop: "180px",
																		paddingBottom: "10px",
																		paddingLeft: "60px",
																	}}
																>
																	Maestro for Analysts
																</p>
															</div>
														</Col>
													</Row>
													 */}
                          <Row className="justify-content-md-center">
                            <Col
                              sm={2}
                              md={12}
                              style={{ paddingTop: "5px", textAlign: "center" }}
                            >
                              <div
                                className="service-section text-center"
                                id="services"
                              >
                                <div className="container">
                                  <div className="col-md-12 text-center">
                                    <div className="services">
                                      <Row
                                        className="justify-content-md-center"
                                        style={{
                                          paddingLeft: "25px",
                                          paddingRight: "25px",
                                        }}
                                      >
                                        <Col sm={2} md={4}>
                                          <div data-aos="fade-right">
                                            <div className="ModifiedCards">
                                              <div className="services-icon">
                                                <img
                                                  src={Accelerate1}
                                                  height="60"
                                                  width="60"
                                                  alt="Service"
                                                />
                                              </div>
                                              <div
                                                className="services-description"
                                                style={{ paddingLeft: "10px" }}
                                              >
                                                <h1>
                                                  Accelerate Transformation
                                                </h1>
                                                <p
                                                  style={{
                                                    paddingLeft: "5px",
                                                    color: "black",
                                                  }}
                                                >
                                                  Serves as the foundation for
                                                  transformation use-cases and
                                                  data-centric products through
                                                  centralized data technology.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </Col>

                                        <Col sm={2} md={4}>
                                          <div data-aos="zoom-in">
                                            <div className="ModifiedCards">
                                              <div className="services-icon">
                                                <img
                                                  className="icon-2"
                                                  src={Commercial1}
                                                  height="60"
                                                  width="60"
                                                  alt="Service"
                                                />
                                              </div>
                                              <div className="services-description">
                                                <h1>Commercialization</h1>
                                                <p style={{ color: "black" }}>
                                                  Create new revenue streams
                                                  from platform components
                                                  developed in house or
                                                  co-created with customers and
                                                  partners.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </Col>

                                        <Col sm={2} md={4}>
                                          <div data-aos="fade-left">
                                            <div className="ModifiedCards">
                                              <div className="services-icon">
                                                <img
                                                  className="icon-2"
                                                  src={CostEfficient1}
                                                  height="60"
                                                  width="60"
                                                  alt="Service"
                                                />
                                              </div>
                                              <div className="services-description">
                                                <h1>Cost Efficiency</h1>
                                                <p
                                                  style={{
                                                    color: "black",
                                                    paddingBottom: "20px",
                                                  }}
                                                >
                                                  Enable migration and
                                                  consolidation of data
                                                  infrastructure across brands
                                                  to increase efficiency and
                                                  optimize TOC.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div className="service-section">
                    <div className="container pl-4">
                      <Row className="justify-content-md-center">
                        <Col sm={2} md={12} style={{ paddingTop: "20px" }}>
                          <Row className="justify-content-md-center">
                            <Col
                              sm={2}
                              md={12}
                              style={{
                                paddingBottom: "0px",
                                textAlign: "center",
                                fontSize: "28px",
                              }}
                            >
                              <div data-aos="zoom-in">
                                <p style={{ fontWeight: "bold" }}>
                                  Why Maestro?
                                </p>
                              </div>
                            </Col>
                          </Row>

                          <Row className="justify-content-md-center">
                            <Col
                              sm={2}
                              md={12}
                              style={{
                                paddingTop: "20px",
                                textAlign: "center",
                              }}
                            >
                              <div
                                className="service-section text-center"
                                id="services"
                              >
                                <div className="container">
                                  <div className="col-md-12 text-center">
                                    <div className="services">
                                      <Row
                                        className="justify-content-md-center"
                                        style={{
                                          paddingLeft: "25px",
                                          paddingRight: "25px",
                                        }}
                                      >
                                        <Col sm={2} md={4}>
                                          <div data-aos="fade-right">
                                            <div className="ModifiedCards">
                                              <div className="services-icon">
                                                <img
                                                  src={Stopwatch2}
                                                  height="60"
                                                  width="60"
                                                  alt="Service"
                                                />
                                              </div>
                                              <div
                                                className="services-description"
                                                style={{ paddingLeft: "10px" }}
                                              >
                                                <h1>
                                                  Immediate Value Delivery
                                                </h1>
                                                <p style={{ color: "black" }}>
                                                  Maestro will enable us to
                                                  provide timely prioritization
                                                  and solution building (rather
                                                  than an annual business case),
                                                  and immediate delivery of the
                                                  valuable effects to our users.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </Col>

                                        <Col sm={2} md={4}>
                                          <div data-aos="zoom-in">
                                            <div
                                              className="ModifiedCards"
                                              data-wow-delay="0.3s"
                                            >
                                              <div className="services-icon">
                                                <img
                                                  className="icon-2"
                                                  src={Data1}
                                                  height="60"
                                                  width="60"
                                                  alt="Service"
                                                />
                                              </div>
                                              <div className="services-description">
                                                <h1>Data Enablement</h1>
                                                <p style={{ color: "black" }}>
                                                  Democratization of data for
                                                  front-line users. Access is
                                                  open by default and tools
                                                  lower the barrier-to-entry to
                                                  utilizing data and building
                                                  innovative data products.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </Col>

                                        <Col sm={2} md={4}>
                                          <div data-aos="fade-left">
                                            <div
                                              className="ModifiedCards"
                                              data-wow-delay="0.4s"
                                            >
                                              <div className="services-icon">
                                                <img
                                                  className="icon-3"
                                                  src={Reuse1}
                                                  height="60"
                                                  width="60"
                                                  alt="Service"
                                                />
                                              </div>
                                              <div className="services-description">
                                                <h1>Reusable Components</h1>
                                                <p style={{ color: "black" }}>
                                                  Maestro will be a single,
                                                  centralized platform of data
                                                  and tools that promotes
                                                  collaboration and prevents
                                                  duplicate work by providing
                                                  easy-to-access reusable data
                                                  components.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <Row className="justify-content-md-center">
                    <Col
                      sm={2}
                      md={12}
                      style={{ paddingTop: "5px", textAlign: "center" }}
                    >
                      <div
                        className="service-section text-center"
                        id="services"
                      >
                        <div className="container">
                          <div className="col-md-12 text-center">
                            <Row
                              className="justify-content-md-center"
                              style={{
                                paddingLeft: "25px",
                                paddingRight: "25px",
                                paddingBottom: "40px",
                              }}
                            >
                              <Col sm={2} md={4}>
                                <div data-aos="fade-right">
                                  <div className="left-content">
                                    <img
                                      className="Imagehover"
                                      src={logo1}
                                      alt="Feature 1"
                                      style={{
                                        paddingBottom: "5px",
                                        paddingLeft: "5px",
                                        width: "50%",
                                        height: "40%",
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>

                              <Col sm={2} md={7}>
                                <div data-aos="fade-left">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "25px",
                                      color: "white",
                                      paddingTop: "45px",
                                      paddingBottom: "10px",
                                    }}
                                  >
                                    Microsoft Azure
                                  </p>
                                  <p
                                    style={{
                                      paddingLeft: "5px",
                                      fontWeight: "bold",
                                      paddingRight: "3px",
                                      fontSize: "20px",
                                      color: "white",
                                    }}
                                    className="services-description"
                                  >
                                    The maestro is powered by Azure's set of
                                    cloud services to meet business challenges.
                                    It gives the freedom to build, manage and
                                    deploy applications on a global network.
                                  </p>
                                </div>
                              </Col>
                            </Row>

                            <Row
                              className="justify-content-md-center"
                              style={{
                                paddingLeft: "25px",
                                paddingRight: "25px",
                                paddingBottom: "40px",
                              }}
                            >
                              <Col sm={2} md={7}>
                                <div data-aos="fade-right">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "25px",
                                      color: "white",
                                      paddingTop: "45px",
                                      paddingBottom: "10px",
                                    }}
                                  >
                                    Azure Databricks
                                  </p>
                                  <p
                                    style={{
                                      paddingLeft: "5px",
                                      fontWeight: "bold",
                                      paddingRight: "3px",
                                      fontSize: "20px",
                                      color: "white",
                                    }}
                                    className="services-description"
                                  >
                                    Powered by Apache Spark-based analytics
                                    platform optimized for Azure cloud services,
                                    Databricks enables collaboration among
                                    Maestro data scientists, engineers &
                                    analysts.
                                  </p>
                                </div>
                              </Col>

                              <Col sm={2} md={4}>
                                <div data-aos="fade-left">
                                  <div className="left-content">
                                    <img
                                      className="Imagehover"
                                      src={logo4}
                                      alt="Feature 1"
                                      style={{
                                        paddingBottom: "5px",
                                        paddingLeft: "5px",
                                        width: "70%",
                                        height: "40%",
                                        paddingTop: "30px",
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            <Row
                              className="justify-content-md-center"
                              style={{
                                paddingLeft: "25px",
                                paddingRight: "25px",
                                paddingBottom: "40px",
                              }}
                            >
                              <Col sm={2} md={4}>
                                <div data-aos="fade-right">
                                  <div className="left-content">
                                    <img
                                      className="Imagehover"
                                      src={logo3}
                                      alt="Feature 1"
                                      style={{
                                        paddingTop: "30px",
                                        paddingBottom: "5px",
                                        paddingLeft: "5px",
                                        width: "40%",
                                        height: "30%",
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>

                              <Col sm={2} md={7}>
                                <div data-aos="fade-left">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "25px",
                                      color: "white",
                                      paddingTop: "45px",
                                      paddingBottom: "10px",
                                    }}
                                  >
                                    Azure DevOps
                                  </p>
                                  <p
                                    style={{
                                      paddingLeft: "5px",
                                      fontWeight: "bold",
                                      paddingRight: "3px",
                                      fontSize: "20px",
                                      color: "white",
                                    }}
                                    className="services-description"
                                  >
                                    Driven by Azure DevOps, Maestro is
                                    continuously built, tested and released
                                    using Azure DevOps integrated features such
                                    as Repos, Pipelines, Artifacts, Test Plans &
                                    Boards.
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="bodycontent2">
                  <div className="container">
                    <div className="flex-split">
                      <div data-wow-delay="1s" data-aos="fade-right">
                        <Card className="border-1">
                          <Card.Body>
                            <div className="mt-n2 my-4 h2">
                              <h4 className="font-weight-bolder">
                                Latest Updates
                              </h4>
                            </div>
                            <LatestUpdate data={this.state.data} />
                          </Card.Body>
                        </Card>
                      </div>

                      <div className="f-left wow fadeInUp mr-2">
                        <div data-aos="fade-left">
                          <div className="left-content">
                            <img
                              className="Imagehover"
                              src={aboutImg}
                              alt="Feature 1"
                              style={{
                                paddingBottom: "5px",
                                paddingLeft: "5px",
                                width: "100%",
                              }}
                            />
                          </div>
                        </div>
                        <div data-aos="fade-left">
                          <div className="left-content">
                            <img
                              className="Imagehover"
                              src={components}
                              alt="components"
                              style={{
                                paddingTop: "10px",
                                paddingLeft: "10px",
                                width: "100%",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Row className="justify-content-md-center">
                    <Col
                      sm={2}
                      md={12}
                      style={{ paddingTop: "20px", textAlign: "center" }}
                    >
                      <div
                        className="service-section text-center"
                        id="services"
                      >
                        <div className="container">
                          <div className="col-md-12 text-center">
                            <div className="services">
                              <Row
                                className="justify-content-md-center"
                                style={{
                                  paddingLeft: "16px",
                                  paddingRight: "12px",
                                }}
                              >
                                <Col sm={2} md={3}>
                                  <div data-aos="fade-right">
                                    <div className="FeatureCards">
                                      <div className="services-icon">
                                        <img
                                          src={icon1}
                                          height="60"
                                          width="60"
                                          alt="Service"
                                        />
                                      </div>
                                      <div className="services-description">
                                        <h1>Cloud Infrastructure</h1>
                                        <p
                                          style={{
                                            paddingBottom: "21px",
                                            color: "black",
                                          }}
                                        >
                                          Experience onboarding your product
                                          hassle-free into Azure Cloud.
                                          <br />
                                          <a
                                            target="_blank"
                                            style={{
                                              paddingTop: "10px",
                                              outline: "none",
                                              fontWeight: "bold",
                                            }}
                                            rel="noopener noreferrer"
                                            href="https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=cloud-infrastructure"
                                          >
                                            Explore more...
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Col>

                                <Col sm={2} md={3}>
                                  <div data-aos="zoom-in">
                                    <div className="FeatureCards">
                                      <div className="services-icon">
                                        <img
                                          className="icon-2"
                                          src={icon2}
                                          height="60"
                                          width="60"
                                          alt="Service"
                                        />
                                      </div>
                                      <div className="services-description">
                                        <h1>Azure DevOps Automated</h1>
                                        <p
                                          style={{
                                            paddingBottom: "21px",
                                            color: "black",
                                          }}
                                        >
                                          Facilitating Engineering teams with
                                          the Clicks away code to deployement
                                          automation.
                                          <br />
                                          <a
                                            target="_blank"
                                            style={{
                                              outline: "none",
                                              paddingTop: "10px",
                                              fontWeight: "bold",
                                            }}
                                            rel="noopener noreferrer"
                                            href="https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=azure-devops"
                                          >
                                            Explore more...
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Col>

                                <Col sm={2} md={3}>
                                  <div data-aos="zoom-in">
                                    <div className="FeatureCards">
                                      <div className="services-icon">
                                        <img
                                          className="icon-3"
                                          src={icon4}
                                          height="60"
                                          width="60"
                                          alt="Service"
                                        />
                                      </div>
                                      <div className="services-description">
                                        <h1>Data Access API</h1>
                                        <p style={{ color: "black" }}>
                                          Accessible rich set of data with Rest
                                          APIs. Sphere, Marketing360 and a lot
                                          others rely on it.
                                          <br />
                                          <a
                                            target="_blank"
                                            style={{
                                              outline: "none",
                                              paddingTop: "10px",
                                              fontWeight: "bold",
                                            }}
                                            rel="noopener noreferrer"
                                            href="https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=data-access-api"
                                          >
                                            Explore more...
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Col>

                                <Col sm={2} md={3}>
                                  <div data-aos="fade-left">
                                    <div className="FeatureCards">
                                      <div className="services-icon">
                                        <img
                                          className="icon-3"
                                          src={icon3}
                                          height="60"
                                          width="60"
                                          alt="Service"
                                        />
                                      </div>
                                      <div className="services-description">
                                        <h1>Centralized Data Lake</h1>
                                        <p style={{ color: "black" }}>
                                          Centralized, curated & secured
                                          repository storing all your structured
                                          & unstructured data, at any scale.
                                          <br />
                                          <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              outline: "none",
                                              paddingTop: "10px",
                                              fontWeight: "bold",
                                            }}
                                            href="https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=centralized-data-lake"
                                          >
                                            Explore more...
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <FooterComponent />

              <a id="back-top" className="back-to-top page-scroll" href="#main">
                <i className="feather icon-arrow-up" />
              </a>
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

export default Landing;
